import { createContext } from 'react';
export var CalendarContext = /*#__PURE__*/createContext({});